import React from "react";
import { Paper, Typography } from "@mui/material";
import { GradientBorderSelect } from "../../../components/common/GradientBorderSelect";

interface ExportFormatSelectProps {
  format: string;
  onFormatChange: (value: string) => void;
}

export const ExportFormatSelect: React.FC<ExportFormatSelectProps> = ({
  format,
  onFormatChange,
}) => {
  return (
    <Paper sx={{ p: 2, mb: -1, flexShrink: 0, backgroundColor: "transparent", boxShadow: "none" }}>
      <Typography variant="h6" gutterBottom>
        <span style={{ color: "rgb(50, 225, 170)", fontWeight: "bold", fontSize: "1.5rem" }}>
          ステップ1
        </span>
        <span style={{ color: "black", fontWeight: "500", fontSize: "1.4rem" }}>
          : 出力フォーマット選定
        </span>
      </Typography>
      <GradientBorderSelect
        value={format}
        onChange={onFormatChange}
        label="出力フォーマット"
        options={[
          { value: "itandi", label: "ITANDI BB" },
          { value: "landlord", label: "家主" },
          { value: "managed_building", label: "管理建物" },
          { value: "room", label: "部屋" },
        ]}
        width={220}
      />
    </Paper>
  );
};
